import { useState } from "react";

export default function useDialogStepper(steps, onSubmit) {
  const [activeStep, setActiveStep] = useState(0);
  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;
  const validationSchema = steps[activeStep].validationSchema;
  const renderContent = steps[activeStep].renderContent;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      onSubmit(values, actions);
      return;
    }
    handleNext();
    actions.setTouched({});
    actions.setSubmitting(false);
  };

  return {
    activeStep,
    isFirstStep,
    isLastStep,
    validationSchema,
    renderContent,
    handleNext,
    handleBack,
    handleSubmit,
  };
}
